import { DeserializedAppData } from '@api';

import { getMixPanelPage, MIXPANEL_EVENT_NAMES } from '@shared/api/mixPanel';
import NextLink from '@shared/common/components/NextLink';
import { useAuth } from '@shared/common/providers/AuthProvider';
import { useMixPanel } from '@shared/common/providers/MixPanelProvider';

import StoreAppCard from '@store:web/components/common/AppCard/StoreAppCard';

interface AppRecommendationsSectionsProps {
  app?: DeserializedAppData;
}

const AppRecommendationsSections = ({ app }: AppRecommendationsSectionsProps) => {
  const { recommendedApps: apps = [] } = app || {};

  const { user } = useAuth();
  const { track } = useMixPanel();

  const handleSeeAllClick = () => {
    const page = getMixPanelPage();
    const group = `${app?.attributes.appName} Recommendations`;

    if (user?.id && page) {
      track(MIXPANEL_EVENT_NAMES.SEE_ALL_CLICK, {
        distinct_id: user.id,
        page,
        group,
      });
    }
  };

  return (
    <div className="sm:app-page-section-card">
      <div className="flex justify-between items-baseline mb-8">
        <span className="t-section-title">You might also like</span>

        <NextLink
          href={`/search`}
          className="text-lg font-medium transition-colors text-primary-600 hover:text-primary-700 whitespace-nowrap"
          onClick={handleSeeAllClick}
        >
          See all ››
        </NextLink>
      </div>

      <div className="overflow-hidden">
        <ul className="grid -mx-2 -mb-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {apps.map((appItem) => {
            return (
              <StoreAppCard
                key={appItem.id}
                As="li"
                className="px-2 py-3 border-b border-neutral-600/10"
                app={appItem}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default AppRecommendationsSections;
